import {createAction} from "redux-act";

interface IGameMessageResponse {
	messages: {
		language: string;
		text: string;
	}[];
}

export const fetchGameMessagesSuccess = createAction<IGameMessageResponse>();
export const fetchGameMessageSuccess = createAction<IGameMessageResponse["messages"][number]>();
export const clearGameMessage = createAction();

export const fetchGameMessage = createAction();
